import * as React from "react";
import { forwardRef } from "react";
const SvgBucketIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 23.6 25", style: {
  enableBackground: "new 0 0 23.6 25"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("ellipse", { cx: 11.8, cy: 3.3, rx: 11.6, ry: 3.3 }), /* @__PURE__ */ React.createElement("path", { d: "M11.8,7.4C5.7,7.4,0.6,6.1,0,4.4l3.3,18c0,1.4,3.7,2.4,8.4,2.4s8.4-1.1,8.4-2.4l3.5-18C23,6.1,18,7.4,11.8,7.4z" })));
const ForwardRef = forwardRef(SvgBucketIcon);
export { ForwardRef as ReactComponent };
